import { Query } from '@varo/graphql-schema-types';
import GetDocument from 'services/graphql/queries/GetDocument';
import { useQuery } from 'urql';

type GetDocumentQuery = Pick<Query, 'document'>;

const useGetDocument = (documentId: string) => {
  const [{ data, fetching, error }, executeQuery] = useQuery<GetDocumentQuery>({
    query: GetDocument,
    variables: { id: documentId },
    pause: !documentId,
    requestPolicy: 'network-only',
  });

  return {
    documentDetails: data,
    fetching,
    error,
    executeQuery,
  };
};

export default useGetDocument;
